export default {
	// SET
	SET_ACCOUNTS: (state, arr) => {
		state.accounts = arr;
		localStorage.setItem("campaignAccounts", JSON.stringify(arr));
	},
	SET_ASSIGNED_ACCOUNTS: (state, arr) => {
		state.assignedAccounts = arr;
	},

	// REMOVE
	REMOVE_ACCOUNTS: (state) => {
		state.accounts = [];
		state.assignedAccounts = [];
		localStorage.removeItem("campaignAccounts");
	},
};
